module.exports = ($scope, $uibModalInstance, Api, customStep) ->
  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.customStep = customStep or new Api.WorkflowStepConfig

  handleSave = () ->
    $scope.saving = false
    $uibModalInstance.close()

  $scope.save = (customStepForm) ->
    customStepForm.$submitted = true
    if !customStepForm.$valid
      return
    if not /^https?:\/\//.test($scope.customStep.custom_step_url)
      $scope.customStep.custom_step_url = 'http://' + $scope.customStep.custom_step_url
    $scope.saving = true
    if $scope.customStep.id
      $scope.customStep.$update().then handleSave
    else
      $scope.customStep.$save().then handleSave

  $scope.archive = () ->
    $scope.customStep.archived = true
    $scope.saving = true
    $scope.customStep.$update().then ->
      $scope.saving = false
      $uibModalInstance.close()
